import classNames from 'classnames'
import type { ContactJson } from 'app/types/entities'
import type { PatientJson } from 'app/types/entities'
import { closeModal, showModal } from 'app/lib/modal'
import { debug } from 'lib/logging'
import { useMatchPatientModal } from 'app/components/match-patient-modal/useMatchPatientModal'
import { MatchPatientModalComponent } from 'app/components/match-patient-modal/MatchPatientModalComponent'

type Props = {
  children: React.ReactNode
  contact: ContactJson
  patient: PatientJson
  onClose?: () => void
  className?: string
}

export default function MatchPatientModalLink({ children, contact, patient, onClose, className }: Props) {
  const openItPlease = () => {
    debug(`modal`, `openItPlease`)
    showModal(
      <MatchPatientModal
        contact={contact}
        patient={patient}
        done={() => {
          onClose?.()
          closeModal()
        }}
      />,
      {
        title: `Manage Patient Link`,
        isFullScreen: false,
        removePadding: true,
        is80Percent: true,
        useRadix: true,
      },
    )
  }

  return (
    <>
      <div className={classNames(className, `cursor-pointer`)} onClick={openItPlease}>
        {children}
      </div>
    </>
  )
}

function MatchPatientModal({
  contact,
  patient,
  done,
}: {
  contact: ContactJson
  patient: PatientJson
  done: () => void
}) {
  const props = useMatchPatientModal({ contact, patient, done })
  return <MatchPatientModalComponent {...props} />
}
